// extracted by mini-css-extract-plugin
export default {"bulb":"NoteFinderPageOverlayNoteBulb_bulb__nB75F","bulbDot":"NoteFinderPageOverlayNoteBulb_bulbDot__2sLXY","bulbLinePoint":"NoteFinderPageOverlayNoteBulb_bulbLinePoint__jUI5T"};